import { Typography, Box } from '@mui/material';

const HeroBanner = () => {
  return (
    <Box sx={{ mt: '4rem' }}>
      <Typography variant='h2' component='h1' sx={{ fontWeight: 'bold' }}>
        Join The 100 Club
      </Typography>
      <Typography sx={{ mt: '1.5rem' }}>
        Our members range from venture-backed deep-tech startups to bootstrapped SMEs, and everything in between. We
        house both founders who are getting started in their journey as well as founders who have exited companies and
        are working on their new ventures. But the key value all our members have in common is friendliness. Running a
        business doesn't have to be lonely, when you have a community of friendly founders to lean on.
      </Typography>
      <Typography sx={{ mt: '1.5rem' }}>Ok, enough talking. Let's get to it. Join below.</Typography>
    </Box>
  );
};

export default HeroBanner;
